import type { ContactHasFundaContactRequestEventFilter } from './types.flow';
import type { Node_NodeContainer_Leaf_Activity_Event_Contact__Input } from '~/graphql/types';

import asHasFilterInput from '../../Primitive/Has/asHasFilterInput';

const asHasFundaContactRequestEventFilterInput = (
  filter: ContactHasFundaContactRequestEventFilter,
): Node_NodeContainer_Leaf_Activity_Event_Contact__Input | null => ({
  App: {
    Funda: {
      ContactRequest: { has: asHasFilterInput(filter.has) },
    },
  },
});

export default asHasFundaContactRequestEventFilterInput;
